module.exports = __webpack_public_path__ + "fonts/element-icons.4520188.ttf";